import { ElMessage } from 'element-plus'
import { ElLoading } from 'element-plus'
const setTips = (data, type, time = 3000) => {
  let text = data.text;
  ElMessage({
    message: text,
    center: true,
    duration: time,
    type
  });
}
const warning = (data, time) => {
  setTips(data, 'warning', time);
}
const error = (data, time) => {
  setTips(data, 'error', time);
}
const info = (data, time) => {
  setTips(data, 'info', time);
}
const success = (data, time) => {
  setTips(data, 'success', time);
}
const loading = (data, text = "Loading", icon = "el-icon-loading") => {
  let downLoading = ElLoading.service({
    lock: true,
    text: text,
    spinner: icon,
    background: 'rgba(255, 255,255, 0.7)',
    ...data
  });
  return downLoading
  // setTimeout(() => { loading.close(); }, time);
}
export default {
  warning,
  error,
  info,
  success,
  loading
}